module.exports = __webpack_public_path__ + "files/observa4.144aa35fabe8a52ad0b4e8d178d22a8e.pdf";